import React from 'react'
import View from '../../../../../components/pdf/View'
import Line from '../../../../../components/pdf/Line'
import Text from '../../../../../components/pdf/Text'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import Separator from '../../../../../components/pdf/Separator'

const NP = () => {
  return (
    <View id="np">
      <Separator weight={8} />

      <Text bold size={20}>
        INVENTÁRIO DE RISCOS E NÍVEL DE PRIORIZAÇÃO (NP)
      </Text>
      <Separator weight={5} />
      <Text>
        A magnitude do risco é a purada pela multiplicação dos escores de probabilidade e gravidade para a determinação
        do risco puro e posteriormente com os controles existentes para avaliação do risco final. A classificação e
        direcionamento de ações é descrita na tabela abaixo.
      </Text>

      <Separator weight={10} />

      <Text color={'#333'} bold>
        Tabela 1 - Definição do escore de probabilidade:
      </Text>
      <Separator weight={5} />

      <Table width={'100%'} useFontBaseColor>
        <TableRow bgColor={'#e2e2e2'} useFontBaseColor>
          <TableCol width={'10%'} useFontBaseColor>
            <Text bold align={'center'}>
              H
            </Text>
          </TableCol>
          <TableCol width={'30%'} useFontBaseColor>
            <Text bold align={'center'}>
              HISTÓRICO
            </Text>
          </TableCol>
          <TableCol width={'10%'} useFontBaseColor>
            <Text bold align={'center'}>
              E
            </Text>
          </TableCol>
          <TableCol width={'30%'} useFontBaseColor>
            <Text bold align={'center'}>
              EXPOSIÇÃO
            </Text>
          </TableCol>
          <TableCol width={'20%'} useFontBaseColor>
            <Text bold align={'center'}>
              CLASSIFICAÇÃO
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>1</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>
              Evento extraordinário, sem histórico de ocorrência ou evento casual e inesperado, muito embora raro, há
              histórico de sua ocorrência
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>1</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>
              Exposição experimentada de forma não programada, sem mensuração do tempo, sendo um acontecimento casual,
              previsível ou não
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Ocasional
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>2</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>
              Evento esperado, de frequência reduzida, e com histórico de ocorrência parcialmente conhecido
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>2</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>
              Exposição experimentada de forma não programada para certos momentos inerentes à sua atividade,
              repetidamente em certos intervalos
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Intermitente
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>3</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Evento usual, com histórico de ocorrência ampiamente conhecido</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>3</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Exposição a agentes nocivos durante todos os dias de trabalho normal</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Habitual
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>4</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>
              Evento repetitivo e constante, as queicas são frequentes e específicas ao agente, com indicadores e
              registros demonstrativos
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>4</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>
              Exposição experimentada pelo segurado durante o exercício das suas atividades normais, não quebrando essa
              permanência com exercício de função de survisão, controle ou comando em geral, ou atividade equivalente em
              outro local, exceto se estas forem realizadas exclusivamente em
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Permanente
            </Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={10} />

      <Text color={'#333'} bold>
        Tabela 2 - Definição do escore de severidade:
      </Text>
      <Separator weight={5} />

      <Table width={'100%'} useFontBaseColor>
        <TableRow bgColor={'#e2e2e2'} useFontBaseColor>
          <TableCol width={'10%'} useFontBaseColor>
            <Text bold align={'center'}>
              CH
            </Text>
          </TableCol>
          <TableCol width={'30%'} useFontBaseColor>
            <Text bold align={'center'}>
              CUSTOS HUMANOS
            </Text>
          </TableCol>
          <TableCol width={'10%'} useFontBaseColor>
            <Text bold align={'center'}>
              CO
            </Text>
          </TableCol>
          <TableCol width={'30%'} useFontBaseColor>
            <Text bold align={'center'}>
              CUSTOS OPERACIONAIS
            </Text>
          </TableCol>
          <TableCol width={'20%'} useFontBaseColor>
            <Text bold align={'center'}>
              CLASSIFICAÇÃO
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>1</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Inexistentes ou efeitos reversíveis levemente prejudiciais</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>1</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Inexistentes, pouca ou nenhuma interferência no processo</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Leve
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>2</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Lesão ou doença sérias, com efeitos reversíveis</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>2</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Pode gerar perdas no processo</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Moderado
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>3</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>
              Lesão ou doenças críticas, com efeitos irreversíveis severos e prejudiciais que podem limitar a capacidade
              funcional
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>3</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Pode gerar perdas importante, parada momentânea</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Sério
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text align={'center'}>4</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Lesão ou doença incapacitante ou fatal</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>4</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align={'center'}>Atraso significativo na produção</Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Severo
            </Text>
          </TableCol>
        </TableRow>
      </Table>
    </View>
  )
}

export default NP
